import React from 'react';
import { ItemBillingEnds, ItemBillingEndsAfterInterval } from '../../../shared/enums';
import { UtilityMethods } from '@mindmemobile/mm-shared-global';

type IProps = {
    billingEnds: keyof typeof ItemBillingEnds;
    billingEndIntervalCount: number;
    billingEndsAfterInterval: keyof typeof ItemBillingEndsAfterInterval;
};

const SubscriptionBillingEnds: React.FC<IProps> = ({
    billingEnds,
    billingEndIntervalCount,
    billingEndsAfterInterval,
}) => {
    function renderBillingEndsOn() {
        switch (ItemBillingEnds[billingEnds]) {
            case ItemBillingEnds.After:
                return `After ${billingEndIntervalCount} ${UtilityMethods.removeLastS(billingEndsAfterInterval)}${billingEndIntervalCount > 1 ? 's' : ''}`;
            case ItemBillingEnds.OnCancellation:
                return <>{ItemBillingEnds.OnCancellation}</>;
            default:
                return <>-</>;
        }
    }
    return <>{renderBillingEndsOn()}</>;
};

export default SubscriptionBillingEnds;
